var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pick-your-own-color-tray tab-yourcolors-content ugc-tray-wrapper"
  }, [_c('div', {
    staticClass: "pick-your-own-color-tray__groups-wrapper"
  }, [_c('swatches-wrapper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeGroup === 'yourcolors',
      expression: "activeGroup === 'yourcolors'"
    }],
    key: "yourcolors",
    staticClass: "pick-your-own-color-tray__yourcolors",
    attrs: {
      "swatchesToRender": _vm.yourColorsData,
      "groupName": "yourcolors",
      "activeGroup": "yourcolors"
    },
    on: {
      "click": function click($event) {
        return _vm.onClick();
      }
    }
  }), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: true,
      expression: "true"
    }],
    staticClass: "pick-your-own-color-tray__pick-your-own swatches-view-swatches-wrapper pick-your-own-color-container"
  }, [_c('div', {
    staticClass: "swatches-view-swatches-wrapper-container"
  }, [_c('div', {
    staticClass: "swatches-view-swatches-wrapper-container-scroll"
  }, [_c('div', {
    staticClass: "swatches-view-swatches-wrapper-container-scroll-content swatches-pick-your-own-color-container swatchesContainerActive"
  }, [_c('div', [_c('div', {
    staticClass: "swatches-view-swatches-wrapper-swatches"
  }, [_vm._m(0), _c('div', {
    staticClass: "v-popover swatches-view-swatches-wrapper-swatches-container",
    on: {
      "!click": function click($event) {
        return _vm.onToggleColorPicker.apply(null, arguments);
      }
    }
  }, [_vm._m(1)])])])])])])])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subgroup-title yourcolors-group"
  }, [_c('span', {
    staticClass: "price"
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                    Pick Your Own\n                  ")]), _c('span', {
    staticClass: "subtitle"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "trigger",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "swatch yourcolors pick-your-own-color-tray__button-wrapper",
    attrs: {
      "data-swatch-id": "10900",
      "data-swatch-name": "",
      "data-subgroup": "yourcolors",
      "data-group": "yourcolors",
      "data-color": "#000"
    }
  }, [_c('div', {
    staticClass: "background"
  })])]);
}]

export { render, staticRenderFns }